<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M4 11.3334L7.33333 8.00008L4 4.66675M8.66667 11.3334L12 8.00008L8.66667 4.66675"
      stroke="currentColor"
      stroke-width="1.336"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
